export const Radius = {
  SMALL: '4px',
  MEDIUM: '8px',
  LARGE: '16px',
  XLARGE: '24px',
  MAXIMUM: '999px',
};
